import { useTranslation } from 'react-i18next';

import { PlanSection } from '~/modules/artist-roster/pages/artist-details/pages/media-planner/components/PlanWizard/components/PlanSection';

export function BudgetSection() {
  const { t } = useTranslation('campaign-planner', {
    keyPrefix: 'digitalCampaigns',
  });

  return (
    <PlanSection title={t('planWizard.sections.budget.title')}>
      {/* eslint-disable-next-line i18next/no-literal-string */}
      <p>@TODO WMG1-659 - Budget</p>
    </PlanSection>
  );
}

BudgetSection.displayName = 'BudgetSection';
